import { AbsoluteFill, Sequence } from "remotion";
import { SCENE, COLORS } from "./constants";
import {
  S01Cold, S02Title, S03Threats, S04Threat1, S05Threat2, S06Threat3,
} from "./scenesA";
import {
  S07Enter, S08Pillar1, S09RLSDemo, S10Pillar2, S11Pillar3, S12Pillar4,
} from "./scenesB";
import {
  S13Pillar5, S14Pillar6, S15Pillar7, S16Summary, S17Compliance, S18Outro,
} from "./scenesC";

export const EAKCSecurity: React.FC = () => {
  return (
    <AbsoluteFill style={{ backgroundColor: COLORS.bg }}>
      <Sequence from={SCENE.cold.start}       durationInFrames={SCENE.cold.duration}><S01Cold /></Sequence>
      <Sequence from={SCENE.title.start}      durationInFrames={SCENE.title.duration}><S02Title /></Sequence>
      <Sequence from={SCENE.threats.start}    durationInFrames={SCENE.threats.duration}><S03Threats /></Sequence>
      <Sequence from={SCENE.threat1.start}    durationInFrames={SCENE.threat1.duration}><S04Threat1 /></Sequence>
      <Sequence from={SCENE.threat2.start}    durationInFrames={SCENE.threat2.duration}><S05Threat2 /></Sequence>
      <Sequence from={SCENE.threat3.start}    durationInFrames={SCENE.threat3.duration}><S06Threat3 /></Sequence>
      <Sequence from={SCENE.enter.start}      durationInFrames={SCENE.enter.duration}><S07Enter /></Sequence>
      <Sequence from={SCENE.pillar1.start}    durationInFrames={SCENE.pillar1.duration}><S08Pillar1 /></Sequence>
      <Sequence from={SCENE.rlsDemo.start}    durationInFrames={SCENE.rlsDemo.duration}><S09RLSDemo /></Sequence>
      <Sequence from={SCENE.pillar2.start}    durationInFrames={SCENE.pillar2.duration}><S10Pillar2 /></Sequence>
      <Sequence from={SCENE.pillar3.start}    durationInFrames={SCENE.pillar3.duration}><S11Pillar3 /></Sequence>
      <Sequence from={SCENE.pillar4.start}    durationInFrames={SCENE.pillar4.duration}><S12Pillar4 /></Sequence>
      <Sequence from={SCENE.pillar5.start}    durationInFrames={SCENE.pillar5.duration}><S13Pillar5 /></Sequence>
      <Sequence from={SCENE.pillar6.start}    durationInFrames={SCENE.pillar6.duration}><S14Pillar6 /></Sequence>
      <Sequence from={SCENE.pillar7.start}    durationInFrames={SCENE.pillar7.duration}><S15Pillar7 /></Sequence>
      <Sequence from={SCENE.summary.start}    durationInFrames={SCENE.summary.duration}><S16Summary /></Sequence>
      <Sequence from={SCENE.compliance.start} durationInFrames={SCENE.compliance.duration}><S17Compliance /></Sequence>
      <Sequence from={SCENE.outro.start}      durationInFrames={SCENE.outro.duration}><S18Outro /></Sequence>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
